import {DropdownOptionProps} from '../../../models/DropdownProps';
import {SELECT_LANGUAGE} from '../../../utils/DropdownOptionPropsUtils';

export const languageResource: DropdownOptionProps[] = [
    { name: SELECT_LANGUAGE, value: SELECT_LANGUAGE },
    { name: 'Afar', value: 'aa' },
    { name: 'Abkhazian', value: 'ab' },
    { name: 'Afrikaans', value: 'af' },
    { name: 'Akan', value: 'ak' },
    { name: 'Albanian', value: 'sq' },
    { name: 'Amharic', value: 'am' },
    { name: 'Arabic', value: 'ar' },
    { name: 'Aragonese', value: 'an' },
    { name: 'Armenian', value: 'hy' },
    { name: 'Assamese', value: 'as' },
    { name: 'Avaric', value: 'av' },
    { name: 'Avestan', value: 'ae' },
    { name: 'Aymara', value: 'ay' },
    { name: 'Azerbaijani', value: 'az' },
    { name: 'Bambara', value: 'bm' },
    { name: 'Bashkir', value: 'ba' },
    { name: 'Basque', value: 'eu' },
    { name: 'Belarusian', value: 'be' },
    { name: 'Bengali', value: 'bn' },
    { name: 'Bihari', value: 'bh' },
    { name: 'Bislama', value: 'bi' },
    { name: 'Bosnian', value: 'bs' },
    { name: 'Breton', value: 'br' },
    { name: 'Bulgarian', value: 'bg' },
    { name: 'Burmese', value: 'my' },
    { name: 'Catalan', value: 'ca' },
    { name: 'Chamorro', value: 'ch' },
    { name: 'Chechen', value: 'ce' },
    { name: 'Chichewa', value: 'ny' },
    { name: 'Chinese', value: 'zh' },
    { name: 'Church_Slavic', value: 'cu' },
    { name: 'Chuvash', value: 'cv' },
    { name: 'Cornish', value: 'kw' },
    { name: 'Corsican', value: 'co' },
    { name: 'Cree', value: 'cr' },
    { name: 'Croatian', value: 'hr' },
    { name: 'Czech', value: 'cs' },
    { name: 'Danish', value: 'da' },
    { name: 'Divehi', value: 'dv' },
    { name: 'Dutch', value: 'nl' },
    { name: 'Dzongkha', value: 'dz' },
    { name: 'English', value: 'en' },
    { name: 'Esperanto', value: 'eo' },
    { name: 'Estonian', value: 'et' },
    { name: 'Ewe', value: 'ee' },
    { name: 'Faroese', value: 'fo' },
    { name: 'Fijian', value: 'fj' },
    { name: 'Finnish', value: 'fi' },
    { name: 'French', value: 'fr' },
    { name: 'Fulah', value: 'ff' },
    { name: 'Gaelic', value: 'gd' },
    { name: 'Galician', value: 'gl' },
    { name: 'Ganda', value: 'lg' },
    { name: 'Georgian', value: 'ka' },
    { name: 'German', value: 'de' },
    { name: 'Greek', value: 'el' },
    { name: 'Guarani', value: 'gn' },
    { name: 'Gujarati', value: 'gu' },
    { name: 'Haitian', value: 'ht' },
    { name: 'Hausa', value: 'ha' },
    { name: 'Hebrew', value: 'he' },
    { name: 'Herero', value: 'hz' },
    { name: 'Hindi', value: 'hi' },
    { name: 'Hiri Motu', value: 'ho' },
    { name: 'Hungarian', value: 'hu' },
    { name: 'Interlingua', value: 'ia' },
    { name: 'Indonesian', value: 'id' },
    { name: 'Interlingue', value: 'ie' },
    { name: 'Irish', value: 'ga' },
    { name: 'Igbo', value: 'ig' },
    { name: 'Inupiaq', value: 'ik' },
    { name: 'Ido', value: 'io' },
    { name: 'Icelandic', value: 'is' },
    { name: 'Italian', value: 'it' },
    { name: 'Inuktitut', value: 'iu' },
    { name: 'Japanese', value: 'ja' },
    { name: 'Javanese', value: 'jv' },
    { name: 'Kalaallisut', value: 'kl' },
    { name: 'Kannada', value: 'kn' },
    { name: 'Kanuri', value: 'kr' },
    { name: 'Kashmiri', value: 'ks' },
    { name: 'Kazakh', value: 'kk' },
    { name: 'Khmer', value: 'km' },
    { name: 'Kikuyu', value: 'ki' },
    { name: 'Kinyarwanda', value: 'rw' },
    { name: 'Kirghiz', value: 'ky' },
    { name: 'Komi', value: 'kv' },
    { name: 'Kongo', value: 'kg' },
    { name: 'Korean', value: 'ko' },
    { name: 'Kuanyama', value: 'kj' },
    { name: 'Kurdish', value: 'ku' },
    { name: 'Lao', value: 'lo' },
    { name: 'Latin', value: 'la' },
    { name: 'Latvian', value: 'lv' },
    { name: 'Limburgan', value: 'li' },
    { name: 'Lingala', value: 'ln' },
    { name: 'Lithuanian', value: 'lt' },
    { name: 'Luba-Katanga', value: 'lu' },
    { name: 'Luxembourgish', value: 'lb' },
    { name: 'Macedonian', value: 'mk' },
    { name: 'Malagasy', value: 'mg' },
    { name: 'Malay', value: 'ms' },
    { name: 'Malayalam', value: 'ml' },
    { name: 'Maltese', value: 'mt' },
    { name: 'Manx', value: 'gv' },
    { name: 'Maori', value: 'mi' },
    { name: 'Marathi', value: 'mr' },
    { name: 'Marshallese', value: 'mh' },
    { name: 'Mongolian', value: 'mn' },
    { name: 'Nauru', value: 'na' },
    { name: 'Navajo', value: 'nv' },
    { name: 'Ndebele, North', value: 'nd' },
    { name: 'Ndebele, South', value: 'nr' },
    { name: 'Ndonga', value: 'ng' },
    { name: 'Nepali', value: 'ne' },
    { name: 'Norwegian', value: 'no' },
    { name: 'Norwegian Bokmål', value: 'nb' },
    { name: 'Norwegian Nynorsk', value: 'nn' },
    { name: 'Occitan', value: 'oc' },
    { name: 'Ojibwa', value: 'oj' },
    { name: 'Oriya', value: 'or' },
    { name: 'Oromo', value: 'om' },
    { name: 'Ossetian', value: 'os' },
    { name: 'Pali', value: 'pi' },
    { name: 'Pashto', value: 'ps' },
    { name: 'Persian', value: 'fa' },
    { name: 'Polish', value: 'pl' },
    { name: 'Portuguese', value: 'pt' },
    { name: 'Punjabi', value: 'pa' },
    { name: 'Quechua', value: 'qu' },
    { name: 'Romansh', value: 'rm' },
    { name: 'Romanian', value: 'ro' },
    { name: 'Rundi', value: 'rn' },
    { name: 'Russian', value: 'ru' },
    { name: 'Samoan', value: 'sm' },
    { name: 'Sango', value: 'sg' },
    { name: 'Sanskrit', value: 'sa' },
    { name: 'Sardinian', value: 'sc' },
    { name: 'Serbian', value: 'sr' },
    { name: 'Shona', value: 'sn' },
    { name: 'Sichuan Yi', value: 'ii' },
    { name: 'Sindhi', value: 'sd' },
    { name: 'Sinhala', value: 'si' },
    { name: 'Slovak', value: 'sk' },
    { name: 'Slovenian', value: 'sl' },
    { name: 'Somali', value: 'so' },
    { name: 'Sotho, Southern', value: 'st' },
    { name: 'South Ndebele', value: 'nr' },
    { name: 'Spanish', value: 'es' },
    { name: 'Sundanese', value: 'su' },
    { name: 'Swahili', value: 'sw' },
    { name: 'Swati', value: 'ss' },
    { name: 'Swedish', value: 'sv' },
    { name: 'Tagalog', value: 'tl' },
    { name: 'Tahitian', value: 'ty' },
    { name: 'Tajik', value: 'tg' },
    { name: 'Tamil', value: 'ta' },
    { name: 'Tatar', value: 'tt' },
    { name: 'Telugu', value: 'te' },
    { name: 'Thai', value: 'th' },
    { name: 'Tibetan', value: 'bo' },
    { name: 'Tigrinya', value: 'ti' },
    { name: 'Tonga', value: 'to' },
    { name: 'Tsonga', value: 'ts' },
    { name: 'Tswana', value: 'tn' },
    { name: 'Turkish', value: 'tr' },
    { name: 'Turkmen', value: 'tk' },
    { name: 'Twi', value: 'tw' },
    { name: 'Uighur', value: 'ug' },
    { name: 'Ukrainian', value: 'uk' },
    { name: 'Urdu', value: 'ur' },
    { name: 'Uzbek', value: 'uz' },
    { name: 'Venda', value: 've' },
    { name: 'Vietnamese', value: 'vi' },
    { name: 'Volapük', value: 'vo' },
    { name: 'Walloon', value: 'wa' },
    { name: 'Welsh', value: 'cy' },
    { name: 'Western Frisian', value: 'fy' },
    { name: 'Wolof', value: 'wo' },
    { name: 'Xhosa', value: 'xh' },
    { name: 'Yiddish', value: 'yi' },
    { name: 'Yoruba', value: 'yo' },
    { name: 'Zhuang', value: 'za' },
    { name: 'Zulu', value: 'zu' }
];
